package fr.anthony.abkweb.model

data class Contact(
    val icon: String,
    val title: String,
    val description: String,
    val actionText: String,
    val actionLink: String
)
